import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { isEmpty } from 'lodash';

import { Dropdown } from '@telus/d2c-core';

import { DropdownCommon } from '@telus/d2c-core/lib/common';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'telus-dropdown',
  templateUrl: 'dropdown.html',
  styleUrls: ['./dropdown.scss'],
})
export class TelusDropdownComponent implements OnInit, OnChanges {
  @Input() items: Dropdown[];
  @Input() defaultText: string;
  @Input() disabled = false;
  @Input() style = 'default';
  @Input() showSpinner = false;
  @Input() showSearchbar = true;
  @Input() multiple: boolean;
  // Properties for dropdowns where you can
  // search using a service as source
  @Input() source = '';
  @Input() sourceParameter = '';
  @Input() sourceDisplayField = '';
  @Input() ionSearchDebounceTime = 250;

  @Input() fetchOnDemand = false;

  @Output() getFromSourceAction = new EventEmitter();

  @Output() selectedAction = new EventEmitter<Dropdown>();
  @Output() filterSelection = new EventEmitter();
  @Output() fetchData = new EventEmitter<string>();

  showItems = false;
  filteredList: Dropdown[] = [];
  text = '';
  searchText = '';
  clickObservable$ = fromEvent(document, 'click');
  canModify = false;
  popoverIsVisible = false;

  constructor() {}

  ngOnInit() {
    if (this.disabled) {
      this.text = this.defaultText;
    } else {
      this.clickObservable$.subscribe(() => (this.showItems = false));
      this.text = this.defaultText
        ? this.defaultText
        : DropdownCommon.selectOption;

      if (this.items && this.items.length > 0) {
        this.filteredList = [...this.items];
      } else {
        this.filteredList = [];
      }
    }
  }

  ngOnChanges({ items, defaultText }: SimpleChanges) {
    if (defaultText) {
      this.text = this.defaultText
        ? this.defaultText
        : DropdownCommon.selectOption;
    } else if (items) {
      if (!isEmpty(this.items)) {
        this.filteredList = [...this.items];
      } else {
        this.filteredList = [];
      }
    }
  }

  onShowItems(e: Event) {
    e.stopPropagation();

    if (this.disabled) {
      return;
    }

    this.showItems = !this.showItems;

    if (this.items && this.items.length > 0) {
      this.filteredList = [...this.items];
    } else {
      this.filteredList = [];
    }
  }

  searchClick(e: Event) {
    e.stopPropagation();
  }

  getFilterValue(inputValue) {
    const text = inputValue.detail.value;
    if (this.fetchOnDemand) {
      this.fetchData.emit(text);
    }

    if (text === '' || text === DropdownCommon.selectOption) {
      if (this.items && this.items.length) {
        this.filteredList = [...this.items];
      } else {
        this.filteredList = [];
      }

      return;
    }

    if (
      this.source !== undefined &&
      this.sourceParameter !== '' &&
      this.sourceDisplayField !== ''
    ) {
      const action = {
        source: this.source,
        sourceParameter: this.sourceParameter,
        sourceDisplayField: this.sourceDisplayField,
        textValue: text,
      };
      this.getFromSourceAction.emit(action);
    } else {
      if (!isEmpty(this.items)) {
        this.filteredList = [
          ...this.items.filter((i) =>
            i.text.toLowerCase().includes(text.toLowerCase())
          ),
        ];
      } else {
        this.filteredList = [];
      }
    }
  }

  onAction(e: Event, action: Dropdown) {
    e.stopPropagation();

    if (!this.multiple) {
      this.showItems = false;
      this.searchText = '';
      this.text = action.text;
      this.selectedAction.emit(action);
    } else {
      action.checked = !action.checked;

      this.onSelectItems(action);
    }
  }

  onCheckboxClick(e: Event, action: Dropdown) {
    e.stopPropagation();

    setTimeout(() => this.onSelectItems(action), 0);
  }

  onSelectItems(action: Dropdown) {
    this.text = this.items
      .filter((i) => i.value !== '' && i.checked)
      .map((i) => i.text)
      .join(', ');

    if (!this.text) {
      this.text = this.defaultText ?? DropdownCommon.selectOption;
    }

    this.filterSelection.emit(this.filteredList.filter((i) => i.checked));
    this.selectedAction.emit({
      ...action,
      multiple: this.multiple,
    });
  }
}
